// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__LqrR6","actionLabel":"styles_actionLabel__LeX_9","button":"styles_button__iS4f4"};